import { utils } from '../../tools/Utils.js';
import { AlertNoteComponentCss } from './AlertNoteComponent.tpl.js';

class AlertNoteComponent extends HTMLElement {
    static get observedAttributes() {
        return ['type', 'outline'];
    }
    constructor() {
        super();
        this.shadow = this.attachShadow({ mode: 'open' });
    }
    attributeChangedCallback() {
        this.render();
    }
    connectedCallback() {
        this.render();
    }
    set type(val) {
        this.setAttribute('type', val);
    }
    get type() {
        return this.getAttribute('type') || 'info';
    }
    render() {
        const icon = this.getIcon(this.type);
        const classes = ['alert-note', this.type];
        if (this.hasAttribute('outline'))
            classes.push('outline');
        this.shadow.innerHTML = `
            <style>${AlertNoteComponentCss}</style>
            <div class="${classes.join(' ')}">
                ${icon}
                <div class="alert-content">
                    <slot></slot>
                </div>
            </div>
        `;
    }
    getIcon(type) {
        switch (type) {
            case 'error': return utils.createSvg('error-circle');
            case 'success': return utils.createSvg('check-circle');
            case 'warning': return utils.createSvg('warning');
            default: return utils.createSvg('info');
        }
    }
}

export { AlertNoteComponent };
